import { Actions } from '../enums/ActionEnums';
import { ActionType } from '../models/appContext';
import { MembershipType } from '../models/membership';

export const membershipReducer = (
  state: MembershipType | null,
  action: ActionType
): MembershipType | null => {
  switch (action.type) {
    case Actions.SetSelectedMembership:
      return { ...action.payload };
    case Actions.ResetSelectedMembership:
      return null;
    default:
      return state;
  }
};
